export interface CompanyContact {
  type: string;
  phoneNumber?: string;
  whatsApp?: string;
  email?: string;
  hoursAvailable?: string;
  displayToDriver?: boolean;
}

const TYPE_LABELS: Record<string, string> = {
  dispatch: 'Dispatch',
  safetyDepartment: 'Safety Department',
  administration: 'Administration'
};

export function getDriverVisibleCompanyContacts(contacts: unknown): CompanyContact[] {
  if (!Array.isArray(contacts)) {
    return [];
  }
  return contacts.filter(
    (c): c is CompanyContact =>
      !!c &&
      typeof c === 'object' &&
      'type' in c &&
      typeof (c as CompanyContact).type === 'string' &&
      (c as CompanyContact).displayToDriver === true
  );
}

export function formatCompanyContactTypeLabel(type: string): string {
  if (!type) {
    return '';
  }
  const mapped = TYPE_LABELS[type];
  if (mapped) {
    return mapped;
  }
  return type
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, s => s.toUpperCase())
    .trim();
}

/** Digits only, for wa.me links */
export function whatsappNumberForUrl(whatsApp: string | undefined): string {
  if (!whatsApp) {
    return '';
  }
  return whatsApp.replace(/\D/g, '');
}
